import { render } from "./WaqfList.vue?vue&type=template&id=553868f3&scoped=true"
import script from "./WaqfList.vue?vue&type=script&lang=js"
export * from "./WaqfList.vue?vue&type=script&lang=js"

import "./WaqfList.vue?vue&type=style&index=0&id=553868f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553868f3"]])

export default __exports__